import type { PartnersQueryParams } from "./usePartnersQuery";

export const PARTNERS_QUERY_KEYS = {
  all: ["PARTNERS"] as const,
  overview: (params: PartnersQueryParams) =>
    [...PARTNERS_QUERY_KEYS.all, "OVERVIEW", params] as const,
  detail: (partnerID: string) =>
    [...["PARTNERS"], "DETAIL", partnerID] as const,
  supervisorSearch: [...["PARTNERS"], "SUPERVISOR_SEARCH"] as const,
  modules: (partnerID: string) =>
    [...["PARTNERS"], "MODULES", partnerID] as const,
  documents: (partnerID: string) =>
    [...["PARTNERS"], "DOCUMENTS", partnerID] as const,
} as const;
